<template>
    <div class="menu">
        <div class="menu_box">
            <img src="@/../static/image/logo-min.png" />
            <div class="menu_list">
                <ul>
                    <li @click="router.push({path:'/'})" :class="{ active: isActive('/', null) }">首页</li>
                    <li @click="router.push({path:'/article',query:{grade:1}})" :class="{ active: isActive('/article', {grade:1}) }">一级听力</li>
                    <li @click="router.push({path:'/article',query:{grade:2}})" :class="{ active: isActive('/article', {grade:2}) }">二级听力</li>
                    <li @click="router.push({path:'/article',query:{grade:3}})" :class="{ active: isActive('/article', {grade:3}) }">三级听力</li>
                    <li @click="router.push({path:'/article',query:{grade:4}})" :class="{ active: isActive('/article', {grade:4}) }">专四听力</li>
                    <!-- <li @click="temNone" :class="{ active: isActive('/article', {grade:5}) }">专八听力</li> -->
                    <li @click="router.push({path:'/lelts'})" :class="{ active: isActive('/lelts') }">雅思听力</li>
                    <li @click="router.push({path:'/aieng'})" :class="{ active: isActive('/aieng') }">口语练习</li>
                </ul>
            </div>
            <div class="menu_btn">

                <div v-if="Object.keys(userInfo).length == 0">
                    <el-button @click="router.push({path:'/login'})" style="color: #000;" type="primary" link>登录</el-button>
                    <el-button class="regist_button" type="primary" round>立即注册</el-button>
                </div>
                <div class="userinfo" v-else>
                    <el-image :src="userInfo.avatar" />
                    <el-dropdown @command="handleCommand" class="no-border">
                        <span class="el-dropdown-link">
                            {{userInfo.nickname || userInfo.username}}
                        </span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item command="a">个人中心</el-dropdown-item>
                                <el-dropdown-item command="b">退出</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { useRoute,useRouter } from 'vue-router'
import { ref } from 'vue'
import { logout } from '@/api/user'
import { ElMessage } from 'element-plus'
export default {
    name:'HeaderCompent',

    setup(){
        const router = useRouter()
        const route = useRoute();
        const userInfo = ref(localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {})

        const isActive = (path, query) => {
            if(query === null) {
                return route.path === path && Object.keys(route.query).length === 0;
            }
            return route.path === path && route.query.grade == query?.grade;
        };

        const handleCommand = async (command)=>{
            if(command == 'a'){
                localStorage.setItem('activeIndex','1')
                const targetPath = userInfo.value.type == 1 ? '/plan' : '/stuplan';
                router.push({path:targetPath}).catch(() => {});
            }else{
                const res = await logout()
                if(res.code){
                    localStorage.clear()
                    router.push({path:'/login'})
                }
            }
        }

        const temNone = ()=>{
            ElMessage.error('暂未开放')
        }

        return {
            isActive,
            handleCommand,
            router,
            userInfo,
            temNone
        }


    }
}
</script>
<style scoped>
.no-border .el-dropdown-link,
.no-border:hover .el-dropdown-link,
.no-border:focus .el-dropdown-link {
    border: none !important;
    outline: none !important;
}

.no-border .el-dropdown__caret-button,
.no-border:hover .el-dropdown__caret-button {
    border: none !important;
}
.menu{
    width: 100%;
    height: 72px;
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    backdrop-filter: blur(10px);
    background-color: rgba(255, 255, 255, 0.7);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    transition-duration: 300ms;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    position: sticky;
    top: 0;
    z-index: 99;
}
.menu_box{
    max-width: 1500px;
    margin: 0 auto;
}
.menu_box img{
    float: left;
    margin-top: 11px;
}
.menu_list ul {
    list-style-type: none;
    margin-left: 200px;
    margin: 0;
}
.menu_list ul li{
    float: left;
    width: 100px;
    line-height: 72px;
    color: #000;
    cursor: pointer;
}
.menu_list :hover{
    color: #165DFF;
}
.menu_btn{
    float: right;
    line-height: 72px;
}
.menu_btn :deep(.el-button){
    font-size: 16px;
}
.menu_btn :deep(.regist_button){
    padding: 20px 25px;
    background: #165DFF;
    border: none;
}
.active{
    color: #165DFF !important;
}
.userinfo{
    cursor: pointer;
}

.userinfo :deep(.el-image){
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: inline-block;
    margin-top: 12px;
}
.el-dropdown-link{
    font-size: 16px;
    margin-top: 30px;
    border: none;
    margin-left: 10px;
}

</style>